<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberInvalidPlanModalDialogClose' type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">Invalid Member Plan</h4>
      </div>
      <div class="modal-body">
        <div class="member-modal-cont">
          This member has an invalid plan and thus cannot be approved. To resolve this issue, you can add a subscription manually through the Member Edit page, or wait for the user to login again (they will be informed of the issue and returned to the payment details stage with their upload proof preserved).
        </div>
      </div>
      <div class='modal-actions'>
        <button id='memberInvalidPlanModalDialogReject' type="button" data-dismiss="modal" class="btn btn-info" (click)="closeDialog">OK</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/member-invalid-plan-modal-dialog/member-invalid-plan-modal-dialog.component.html